/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {optionsTransformer} from '@sekoia/shared/requests/nswagBaseClients/baseClient';
import * as moment from 'moment';

export class BaseClient {
  getBaseUrl(_: string, parsedBaseUrl: string | undefined): string {
    if (parsedBaseUrl) {
      return parsedBaseUrl;
    }

    if (!process.env.INCIDENTS_SERVICE_URL) {
      throw new Error('INCIDENTS_SERVICE_URL must be set in environment');
    }

    return process.env.INCIDENTS_SERVICE_URL;
  }
  
  async transformOptions(options: RequestInit) : Promise<RequestInit> {
    return optionsTransformer.addDefaultHeaders(options);
  }
}

export class IncidentsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-incidents-dev.sekoia.one", baseUrl);
    }

    createIncident(request: CreateIncidentRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/incidents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateIncident(_response);
        });
    }

    protected processCreateIncident(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updateIncidentContent(id: number, request: UpdateIncidentContentRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/incidents/{id}/content";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateIncidentContent(_response);
        });
    }

    protected processUpdateIncidentContent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getIncidentContentDetail(id: number): Promise<IncidentContentDetailResponse> {
        let url_ = this.baseUrl + "/api/incidents/{id}/content";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIncidentContentDetail(_response);
        });
    }

    protected processGetIncidentContentDetail(response: Response): Promise<IncidentContentDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncidentContentDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncidentContentDetailResponse>(<any>null);
    }

    updateIncidentFinalComment(id: number, finalComment: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/incidents/{id}/finalComment";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(finalComment);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateIncidentFinalComment(_response);
        });
    }

    protected processUpdateIncidentFinalComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getIncidentFinalCommentDetail(id: number): Promise<IncidentFinalCommentDetailResponse> {
        let url_ = this.baseUrl + "/api/incidents/{id}/finalComment";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIncidentFinalCommentDetail(_response);
        });
    }

    protected processGetIncidentFinalCommentDetail(response: Response): Promise<IncidentFinalCommentDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncidentFinalCommentDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncidentFinalCommentDetailResponse>(<any>null);
    }

    getIncidentsMetadata(): Promise<IncidentMetadataResponse[]> {
        let url_ = this.baseUrl + "/api/incidents/metadata";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIncidentsMetadata(_response);
        });
    }

    protected processGetIncidentsMetadata(response: Response): Promise<IncidentMetadataResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncidentMetadataResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncidentMetadataResponse[]>(<any>null);
    }

    getIncidentDetail(id: number): Promise<IncidentDetailResponse> {
        let url_ = this.baseUrl + "/api/incidents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIncidentDetail(_response);
        });
    }

    protected processGetIncidentDetail(response: Response): Promise<IncidentDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncidentDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncidentDetailResponse>(<any>null);
    }

    deleteIncident(id: number, request: DeleteIncidentRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/incidents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteIncident(_response);
        });
    }

    protected processDeleteIncident(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getIncidentPrototypeFromTemplate(templateId: string | undefined): Promise<IncidentPrototypeResponse> {
        let url_ = this.baseUrl + "/api/incidents/prototype?";
        if (templateId === null)
            throw new Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIncidentPrototypeFromTemplate(_response);
        });
    }

    protected processGetIncidentPrototypeFromTemplate(response: Response): Promise<IncidentPrototypeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncidentPrototypeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncidentPrototypeResponse>(<any>null);
    }
}

export class IncidentsTemplateClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-incidents-dev.sekoia.one", baseUrl);
    }

    getIncidentTemplates(): Promise<IncidentTemplateResponse[]> {
        let url_ = this.baseUrl + "/api/incidents/templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIncidentTemplates(_response);
        });
    }

    protected processGetIncidentTemplates(response: Response): Promise<IncidentTemplateResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncidentTemplateResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncidentTemplateResponse[]>(<any>null);
    }

    updateIncidentTemplateAccessControlTags(templateId: string, request: UpdateIncidentTemplateAccessControlTagsRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/incidents/templates/{templateId}/accessControlTags";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateIncidentTemplateAccessControlTags(_response);
        });
    }

    protected processUpdateIncidentTemplateAccessControlTags(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class AnalysisClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-incidents-dev.sekoia.one", baseUrl);
    }

    updateAnalysis(incidentId: number, request: UpdateAnalysisRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/incidents/{incidentId}/analysis";
        if (incidentId === undefined || incidentId === null)
            throw new Error("The parameter 'incidentId' must be defined.");
        url_ = url_.replace("{incidentId}", encodeURIComponent("" + incidentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAnalysis(_response);
        });
    }

    protected processUpdateAnalysis(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getIncidentAnalysisDetail(incidentId: number): Promise<IncidentAnalysisDetailResponse> {
        let url_ = this.baseUrl + "/api/incidents/{incidentId}/analysis";
        if (incidentId === undefined || incidentId === null)
            throw new Error("The parameter 'incidentId' must be defined.");
        url_ = url_.replace("{incidentId}", encodeURIComponent("" + incidentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIncidentAnalysisDetail(_response);
        });
    }

    protected processGetIncidentAnalysisDetail(response: Response): Promise<IncidentAnalysisDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncidentAnalysisDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncidentAnalysisDetailResponse>(<any>null);
    }
}

export class ActionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-incidents-dev.sekoia.one", baseUrl);
    }

    getIncidentActionsDetail(incidentId: number): Promise<IncidentActionDetailResponse> {
        let url_ = this.baseUrl + "/api/incidents/{incidentId}/actions";
        if (incidentId === undefined || incidentId === null)
            throw new Error("The parameter 'incidentId' must be defined.");
        url_ = url_.replace("{incidentId}", encodeURIComponent("" + incidentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIncidentActionsDetail(_response);
        });
    }

    protected processGetIncidentActionsDetail(response: Response): Promise<IncidentActionDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncidentActionDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IncidentActionDetailResponse>(<any>null);
    }

    createAction(incidentId: number, request: ActionRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/incidents/{incidentId}/actions";
        if (incidentId === undefined || incidentId === null)
            throw new Error("The parameter 'incidentId' must be defined.");
        url_ = url_.replace("{incidentId}", encodeURIComponent("" + incidentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAction(_response);
        });
    }

    protected processCreateAction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updateAction(incidentId: number, actionId: string, request: ActionRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/incidents/{incidentId}/actions/{actionId}";
        if (incidentId === undefined || incidentId === null)
            throw new Error("The parameter 'incidentId' must be defined.");
        url_ = url_.replace("{incidentId}", encodeURIComponent("" + incidentId));
        if (actionId === undefined || actionId === null)
            throw new Error("The parameter 'actionId' must be defined.");
        url_ = url_.replace("{actionId}", encodeURIComponent("" + actionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAction(_response);
        });
    }

    protected processUpdateAction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    deleteAction(actionId: string, incidentId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/incidents/{incidentId}/actions/{actionId}";
        if (actionId === undefined || actionId === null)
            throw new Error("The parameter 'actionId' must be defined.");
        url_ = url_.replace("{actionId}", encodeURIComponent("" + actionId));
        if (incidentId === undefined || incidentId === null)
            throw new Error("The parameter 'incidentId' must be defined.");
        url_ = url_.replace("{incidentId}", encodeURIComponent("" + incidentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAction(_response);
        });
    }

    protected processDeleteAction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getAction(incidentId: number, actionId: string): Promise<ActionResponse> {
        let url_ = this.baseUrl + "/api/incidents/{incidentId}/actions/{actionId}";
        if (incidentId === undefined || incidentId === null)
            throw new Error("The parameter 'incidentId' must be defined.");
        url_ = url_.replace("{incidentId}", encodeURIComponent("" + incidentId));
        if (actionId === undefined || actionId === null)
            throw new Error("The parameter 'actionId' must be defined.");
        url_ = url_.replace("{actionId}", encodeURIComponent("" + actionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAction(_response);
        });
    }

    protected processGetAction(response: Response): Promise<ActionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActionResponse>(<any>null);
    }

    getPossibleActionTypes(): Promise<ActionTypeResponse[]> {
        let url_ = this.baseUrl + "/api/actiontypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPossibleActionTypes(_response);
        });
    }

    protected processGetPossibleActionTypes(response: Response): Promise<ActionTypeResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActionTypeResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActionTypeResponse[]>(<any>null);
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions!: { [key: string]: any; };

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = this.extensions[key];
            }
        }
        return data; 
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };
}

export class CreateIncidentRequest implements ICreateIncidentRequest {
    templateId!: string;
    organisationId!: string;
    state!: IncidentState;
    departmentId?: string | undefined;
    residentIds!: string[];
    formFields!: FormFieldRequest[];

    constructor(data?: ICreateIncidentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.residentIds = [];
            this.formFields = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.organisationId = _data["organisationId"];
            this.state = _data["state"];
            this.departmentId = _data["departmentId"];
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            if (Array.isArray(_data["formFields"])) {
                this.formFields = [] as any;
                for (let item of _data["formFields"])
                    this.formFields!.push(FormFieldRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateIncidentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIncidentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["organisationId"] = this.organisationId;
        data["state"] = this.state;
        data["departmentId"] = this.departmentId;
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        if (Array.isArray(this.formFields)) {
            data["formFields"] = [];
            for (let item of this.formFields)
                data["formFields"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateIncidentRequest {
    templateId: string;
    organisationId: string;
    state: IncidentState;
    departmentId?: string | undefined;
    residentIds: string[];
    formFields: FormFieldRequest[];
}

export enum IncidentState {
    None = "None",
    Active = "Active",
    Ended = "Ended",
}

export class FormFieldRequest implements IFormFieldRequest {
    id!: string;
    order!: number;
    label!: string;

    protected _discriminator: string;

    constructor(data?: IFormFieldRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "FormFieldRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): FormFieldRequest {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "SingleSelectFormFieldRequest") {
            let result = new SingleSelectFormFieldRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "EditableFormFieldRequest") {
            let result = new EditableFormFieldRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "MultiSelectFormFieldRequest") {
            let result = new MultiSelectFormFieldRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HeaderFormFieldRequest") {
            let result = new HeaderFormFieldRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "TextFormFieldRequest") {
            let result = new TextFormFieldRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DateFormFieldRequest") {
            let result = new DateFormFieldRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DateTimeFormFieldRequest") {
            let result = new DateTimeFormFieldRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "RiskFormFieldRequest") {
            let result = new RiskFormFieldRequest();
            result.init(data);
            return result;
        }
        let result = new FormFieldRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator; 
        data["id"] = this.id;
        data["order"] = this.order;
        data["label"] = this.label;
        return data; 
    }
}

export interface IFormFieldRequest {
    id: string;
    order: number;
    label: string;
}

export class EditableFormFieldRequest extends FormFieldRequest implements IEditableFormFieldRequest {
    mandatory!: boolean;

    constructor(data?: IEditableFormFieldRequest) {
        super(data);
        this._discriminator = "EditableFormFieldRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mandatory = _data["mandatory"];
        }
    }

    static fromJS(data: any): EditableFormFieldRequest {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "SingleSelectFormFieldRequest") {
            let result = new SingleSelectFormFieldRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "MultiSelectFormFieldRequest") {
            let result = new MultiSelectFormFieldRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "TextFormFieldRequest") {
            let result = new TextFormFieldRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DateFormFieldRequest") {
            let result = new DateFormFieldRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DateTimeFormFieldRequest") {
            let result = new DateTimeFormFieldRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "RiskFormFieldRequest") {
            let result = new RiskFormFieldRequest();
            result.init(data);
            return result;
        }
        let result = new EditableFormFieldRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mandatory"] = this.mandatory;
        super.toJSON(data);
        return data; 
    }
}

export interface IEditableFormFieldRequest extends IFormFieldRequest {
    mandatory: boolean;
}

export class SingleSelectFormFieldRequest extends EditableFormFieldRequest implements ISingleSelectFormFieldRequest {
    options!: SelectOptionRequest[];
    hasOther!: boolean;
    otherLabel?: string | undefined;
    otherValue?: string | undefined;
    displayMode!: DisplayMode;
    selectedOption?: SelectOptionRequest | undefined;

    constructor(data?: ISingleSelectFormFieldRequest) {
        super(data);
        if (!data) {
            this.options = [];
        }
        this._discriminator = "SingleSelectFormFieldRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(SelectOptionRequest.fromJS(item));
            }
            this.hasOther = _data["hasOther"];
            this.otherLabel = _data["otherLabel"];
            this.otherValue = _data["otherValue"];
            this.displayMode = _data["displayMode"];
            this.selectedOption = _data["selectedOption"] ? SelectOptionRequest.fromJS(_data["selectedOption"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SingleSelectFormFieldRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SingleSelectFormFieldRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        data["hasOther"] = this.hasOther;
        data["otherLabel"] = this.otherLabel;
        data["otherValue"] = this.otherValue;
        data["displayMode"] = this.displayMode;
        data["selectedOption"] = this.selectedOption ? this.selectedOption.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface ISingleSelectFormFieldRequest extends IEditableFormFieldRequest {
    options: SelectOptionRequest[];
    hasOther: boolean;
    otherLabel?: string | undefined;
    otherValue?: string | undefined;
    displayMode: DisplayMode;
    selectedOption?: SelectOptionRequest | undefined;
}

export class SelectOptionRequest implements ISelectOptionRequest {
    id!: string;
    label!: string;
    order!: number;

    constructor(data?: ISelectOptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): SelectOptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SelectOptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["order"] = this.order;
        return data; 
    }
}

export interface ISelectOptionRequest {
    id: string;
    label: string;
    order: number;
}

export enum DisplayMode {
    List = "List",
    DropDown = "DropDown",
}

export class MultiSelectFormFieldRequest extends EditableFormFieldRequest implements IMultiSelectFormFieldRequest {
    selectedOptions!: SelectOptionRequest[];
    options!: SelectOptionRequest[];
    hasOther!: boolean;
    otherLabel?: string | undefined;
    otherValue?: string | undefined;

    constructor(data?: IMultiSelectFormFieldRequest) {
        super(data);
        if (!data) {
            this.selectedOptions = [];
            this.options = [];
        }
        this._discriminator = "MultiSelectFormFieldRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["selectedOptions"])) {
                this.selectedOptions = [] as any;
                for (let item of _data["selectedOptions"])
                    this.selectedOptions!.push(SelectOptionRequest.fromJS(item));
            }
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(SelectOptionRequest.fromJS(item));
            }
            this.hasOther = _data["hasOther"];
            this.otherLabel = _data["otherLabel"];
            this.otherValue = _data["otherValue"];
        }
    }

    static fromJS(data: any): MultiSelectFormFieldRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MultiSelectFormFieldRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedOptions)) {
            data["selectedOptions"] = [];
            for (let item of this.selectedOptions)
                data["selectedOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        data["hasOther"] = this.hasOther;
        data["otherLabel"] = this.otherLabel;
        data["otherValue"] = this.otherValue;
        super.toJSON(data);
        return data; 
    }
}

export interface IMultiSelectFormFieldRequest extends IEditableFormFieldRequest {
    selectedOptions: SelectOptionRequest[];
    options: SelectOptionRequest[];
    hasOther: boolean;
    otherLabel?: string | undefined;
    otherValue?: string | undefined;
}

export class HeaderFormFieldRequest extends FormFieldRequest implements IHeaderFormFieldRequest {

    constructor(data?: IHeaderFormFieldRequest) {
        super(data);
        this._discriminator = "HeaderFormFieldRequest";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): HeaderFormFieldRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HeaderFormFieldRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IHeaderFormFieldRequest extends IFormFieldRequest {
}

export class TextFormFieldRequest extends EditableFormFieldRequest implements ITextFormFieldRequest {
    value?: string | undefined;

    constructor(data?: ITextFormFieldRequest) {
        super(data);
        this._discriminator = "TextFormFieldRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TextFormFieldRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TextFormFieldRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface ITextFormFieldRequest extends IEditableFormFieldRequest {
    value?: string | undefined;
}

export class DateFormFieldRequest extends EditableFormFieldRequest implements IDateFormFieldRequest {
    value?: moment.Moment | undefined;

    constructor(data?: IDateFormFieldRequest) {
        super(data);
        this._discriminator = "DateFormFieldRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? moment(_data["value"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateFormFieldRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DateFormFieldRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.format('YYYY-MM-DD') : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IDateFormFieldRequest extends IEditableFormFieldRequest {
    value?: moment.Moment | undefined;
}

export class DateTimeFormFieldRequest extends EditableFormFieldRequest implements IDateTimeFormFieldRequest {
    value?: moment.Moment | undefined;

    constructor(data?: IDateTimeFormFieldRequest) {
        super(data);
        this._discriminator = "DateTimeFormFieldRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? moment(_data["value"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateTimeFormFieldRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeFormFieldRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toISOString() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IDateTimeFormFieldRequest extends IEditableFormFieldRequest {
    value?: moment.Moment | undefined;
}

export class RiskFormFieldRequest extends EditableFormFieldRequest implements IRiskFormFieldRequest {
    probabilityLabel!: string;
    probabilityOptions!: RiskOptionRequest[];
    impactLabel!: string;
    impactOptions!: RiskOptionRequest[];
    selectedProbabilityOption?: RiskOptionRequest | undefined;
    selectedImpactOption?: RiskOptionRequest | undefined;

    constructor(data?: IRiskFormFieldRequest) {
        super(data);
        if (!data) {
            this.probabilityOptions = [];
            this.impactOptions = [];
        }
        this._discriminator = "RiskFormFieldRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.probabilityLabel = _data["probabilityLabel"];
            if (Array.isArray(_data["probabilityOptions"])) {
                this.probabilityOptions = [] as any;
                for (let item of _data["probabilityOptions"])
                    this.probabilityOptions!.push(RiskOptionRequest.fromJS(item));
            }
            this.impactLabel = _data["impactLabel"];
            if (Array.isArray(_data["impactOptions"])) {
                this.impactOptions = [] as any;
                for (let item of _data["impactOptions"])
                    this.impactOptions!.push(RiskOptionRequest.fromJS(item));
            }
            this.selectedProbabilityOption = _data["selectedProbabilityOption"] ? RiskOptionRequest.fromJS(_data["selectedProbabilityOption"]) : <any>undefined;
            this.selectedImpactOption = _data["selectedImpactOption"] ? RiskOptionRequest.fromJS(_data["selectedImpactOption"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RiskFormFieldRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RiskFormFieldRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["probabilityLabel"] = this.probabilityLabel;
        if (Array.isArray(this.probabilityOptions)) {
            data["probabilityOptions"] = [];
            for (let item of this.probabilityOptions)
                data["probabilityOptions"].push(item.toJSON());
        }
        data["impactLabel"] = this.impactLabel;
        if (Array.isArray(this.impactOptions)) {
            data["impactOptions"] = [];
            for (let item of this.impactOptions)
                data["impactOptions"].push(item.toJSON());
        }
        data["selectedProbabilityOption"] = this.selectedProbabilityOption ? this.selectedProbabilityOption.toJSON() : <any>undefined;
        data["selectedImpactOption"] = this.selectedImpactOption ? this.selectedImpactOption.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IRiskFormFieldRequest extends IEditableFormFieldRequest {
    probabilityLabel: string;
    probabilityOptions: RiskOptionRequest[];
    impactLabel: string;
    impactOptions: RiskOptionRequest[];
    selectedProbabilityOption?: RiskOptionRequest | undefined;
    selectedImpactOption?: RiskOptionRequest | undefined;
}

export class RiskOptionRequest implements IRiskOptionRequest {
    id!: string;
    label!: string;
    order!: number;
    riskValue!: number;

    constructor(data?: IRiskOptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.order = _data["order"];
            this.riskValue = _data["riskValue"];
        }
    }

    static fromJS(data: any): RiskOptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RiskOptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["order"] = this.order;
        data["riskValue"] = this.riskValue;
        return data; 
    }
}

export interface IRiskOptionRequest {
    id: string;
    label: string;
    order: number;
    riskValue: number;
}

export class UpdateIncidentContentRequest implements IUpdateIncidentContentRequest {
    residentIds!: string[];
    formFields!: FormFieldRequest[];
    state!: IncidentState;
    departmentId?: string | undefined;

    constructor(data?: IUpdateIncidentContentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.residentIds = [];
            this.formFields = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            if (Array.isArray(_data["formFields"])) {
                this.formFields = [] as any;
                for (let item of _data["formFields"])
                    this.formFields!.push(FormFieldRequest.fromJS(item));
            }
            this.state = _data["state"];
            this.departmentId = _data["departmentId"];
        }
    }

    static fromJS(data: any): UpdateIncidentContentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIncidentContentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        if (Array.isArray(this.formFields)) {
            data["formFields"] = [];
            for (let item of this.formFields)
                data["formFields"].push(item.toJSON());
        }
        data["state"] = this.state;
        data["departmentId"] = this.departmentId;
        return data; 
    }
}

export interface IUpdateIncidentContentRequest {
    residentIds: string[];
    formFields: FormFieldRequest[];
    state: IncidentState;
    departmentId?: string | undefined;
}

export class IncidentMetadataResponse implements IIncidentMetadataResponse {
    incidentId!: number;
    incidentTitle!: string;
    createdAt!: moment.Moment;
    createdBy!: string;
    organisationId!: string;
    departmentId?: string | undefined;
    state!: IncidentState;
    employeesResponsibleForActions!: string[];
    employeesResponsibleForFollowups!: string[];
    employeesResponsibleForAnalysis!: string[];
    accessControlTagIds!: string[];

    constructor(data?: IIncidentMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.employeesResponsibleForActions = [];
            this.employeesResponsibleForFollowups = [];
            this.employeesResponsibleForAnalysis = [];
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incidentId = _data["incidentId"];
            this.incidentTitle = _data["incidentTitle"];
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.organisationId = _data["organisationId"];
            this.departmentId = _data["departmentId"];
            this.state = _data["state"];
            if (Array.isArray(_data["employeesResponsibleForActions"])) {
                this.employeesResponsibleForActions = [] as any;
                for (let item of _data["employeesResponsibleForActions"])
                    this.employeesResponsibleForActions!.push(item);
            }
            if (Array.isArray(_data["employeesResponsibleForFollowups"])) {
                this.employeesResponsibleForFollowups = [] as any;
                for (let item of _data["employeesResponsibleForFollowups"])
                    this.employeesResponsibleForFollowups!.push(item);
            }
            if (Array.isArray(_data["employeesResponsibleForAnalysis"])) {
                this.employeesResponsibleForAnalysis = [] as any;
                for (let item of _data["employeesResponsibleForAnalysis"])
                    this.employeesResponsibleForAnalysis!.push(item);
            }
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): IncidentMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidentId"] = this.incidentId;
        data["incidentTitle"] = this.incidentTitle;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["organisationId"] = this.organisationId;
        data["departmentId"] = this.departmentId;
        data["state"] = this.state;
        if (Array.isArray(this.employeesResponsibleForActions)) {
            data["employeesResponsibleForActions"] = [];
            for (let item of this.employeesResponsibleForActions)
                data["employeesResponsibleForActions"].push(item);
        }
        if (Array.isArray(this.employeesResponsibleForFollowups)) {
            data["employeesResponsibleForFollowups"] = [];
            for (let item of this.employeesResponsibleForFollowups)
                data["employeesResponsibleForFollowups"].push(item);
        }
        if (Array.isArray(this.employeesResponsibleForAnalysis)) {
            data["employeesResponsibleForAnalysis"] = [];
            for (let item of this.employeesResponsibleForAnalysis)
                data["employeesResponsibleForAnalysis"].push(item);
        }
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        return data; 
    }
}

export interface IIncidentMetadataResponse {
    incidentId: number;
    incidentTitle: string;
    createdAt: moment.Moment;
    createdBy: string;
    organisationId: string;
    departmentId?: string | undefined;
    state: IncidentState;
    employeesResponsibleForActions: string[];
    employeesResponsibleForFollowups: string[];
    employeesResponsibleForAnalysis: string[];
    accessControlTagIds: string[];
}

export class IncidentDetailResponse implements IIncidentDetailResponse {
    id!: number;
    title!: string;
    organisationId!: string;
    finalComment?: string | undefined;
    departmentId?: string | undefined;
    state!: IncidentState;
    content!: ContentResponse;
    analysis!: AnalysisResponse;
    actions!: ActionResponse[];

    constructor(data?: IIncidentDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.content = new ContentResponse();
            this.analysis = new AnalysisResponse();
            this.actions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.organisationId = _data["organisationId"];
            this.finalComment = _data["finalComment"];
            this.departmentId = _data["departmentId"];
            this.state = _data["state"];
            this.content = _data["content"] ? ContentResponse.fromJS(_data["content"]) : new ContentResponse();
            this.analysis = _data["analysis"] ? AnalysisResponse.fromJS(_data["analysis"]) : new AnalysisResponse();
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(ActionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IncidentDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["organisationId"] = this.organisationId;
        data["finalComment"] = this.finalComment;
        data["departmentId"] = this.departmentId;
        data["state"] = this.state;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["analysis"] = this.analysis ? this.analysis.toJSON() : <any>undefined;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIncidentDetailResponse {
    id: number;
    title: string;
    organisationId: string;
    finalComment?: string | undefined;
    departmentId?: string | undefined;
    state: IncidentState;
    content: ContentResponse;
    analysis: AnalysisResponse;
    actions: ActionResponse[];
}

export class ContentResponse implements IContentResponse {
    residentIds!: string[];
    formFields!: FormFieldResponse[];

    constructor(data?: IContentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.residentIds = [];
            this.formFields = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            if (Array.isArray(_data["formFields"])) {
                this.formFields = [] as any;
                for (let item of _data["formFields"])
                    this.formFields!.push(FormFieldResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        if (Array.isArray(this.formFields)) {
            data["formFields"] = [];
            for (let item of this.formFields)
                data["formFields"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IContentResponse {
    residentIds: string[];
    formFields: FormFieldResponse[];
}

export class FormFieldResponse implements IFormFieldResponse {
    id!: string;
    order!: number;
    label!: string;

    protected _discriminator: string;

    constructor(data?: IFormFieldResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "FormFieldResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): FormFieldResponse {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "SingleSelectFormFieldResponse") {
            let result = new SingleSelectFormFieldResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "EditableFormFieldResponse") {
            let result = new EditableFormFieldResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "MultiSelectFormFieldResponse") {
            let result = new MultiSelectFormFieldResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "RiskFormFieldResponse") {
            let result = new RiskFormFieldResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HeaderFormFieldResponse") {
            let result = new HeaderFormFieldResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "TextFormFieldResponse") {
            let result = new TextFormFieldResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DateFormFieldResponse") {
            let result = new DateFormFieldResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DateTimeFormFieldResponse") {
            let result = new DateTimeFormFieldResponse();
            result.init(data);
            return result;
        }
        let result = new FormFieldResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator; 
        data["id"] = this.id;
        data["order"] = this.order;
        data["label"] = this.label;
        return data; 
    }
}

export interface IFormFieldResponse {
    id: string;
    order: number;
    label: string;
}

export class EditableFormFieldResponse extends FormFieldResponse implements IEditableFormFieldResponse {
    mandatory!: boolean;

    constructor(data?: IEditableFormFieldResponse) {
        super(data);
        this._discriminator = "EditableFormFieldResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mandatory = _data["mandatory"];
        }
    }

    static fromJS(data: any): EditableFormFieldResponse {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "SingleSelectFormFieldResponse") {
            let result = new SingleSelectFormFieldResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "MultiSelectFormFieldResponse") {
            let result = new MultiSelectFormFieldResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "RiskFormFieldResponse") {
            let result = new RiskFormFieldResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "TextFormFieldResponse") {
            let result = new TextFormFieldResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DateFormFieldResponse") {
            let result = new DateFormFieldResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DateTimeFormFieldResponse") {
            let result = new DateTimeFormFieldResponse();
            result.init(data);
            return result;
        }
        let result = new EditableFormFieldResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mandatory"] = this.mandatory;
        super.toJSON(data);
        return data; 
    }
}

export interface IEditableFormFieldResponse extends IFormFieldResponse {
    mandatory: boolean;
}

export class SingleSelectFormFieldResponse extends EditableFormFieldResponse implements ISingleSelectFormFieldResponse {
    options!: SelectOptionResponse[];
    selectedOption?: SelectOptionResponse | undefined;
    hasOther!: boolean;
    otherLabel?: string | undefined;
    otherValue?: string | undefined;
    displayMode!: DisplayMode;

    constructor(data?: ISingleSelectFormFieldResponse) {
        super(data);
        if (!data) {
            this.options = [];
        }
        this._discriminator = "SingleSelectFormFieldResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(SelectOptionResponse.fromJS(item));
            }
            this.selectedOption = _data["selectedOption"] ? SelectOptionResponse.fromJS(_data["selectedOption"]) : <any>undefined;
            this.hasOther = _data["hasOther"];
            this.otherLabel = _data["otherLabel"];
            this.otherValue = _data["otherValue"];
            this.displayMode = _data["displayMode"];
        }
    }

    static fromJS(data: any): SingleSelectFormFieldResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SingleSelectFormFieldResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        data["selectedOption"] = this.selectedOption ? this.selectedOption.toJSON() : <any>undefined;
        data["hasOther"] = this.hasOther;
        data["otherLabel"] = this.otherLabel;
        data["otherValue"] = this.otherValue;
        data["displayMode"] = this.displayMode;
        super.toJSON(data);
        return data; 
    }
}

export interface ISingleSelectFormFieldResponse extends IEditableFormFieldResponse {
    options: SelectOptionResponse[];
    selectedOption?: SelectOptionResponse | undefined;
    hasOther: boolean;
    otherLabel?: string | undefined;
    otherValue?: string | undefined;
    displayMode: DisplayMode;
}

export class SelectOptionResponse implements ISelectOptionResponse {
    id!: string;
    label!: string;
    order!: number;

    constructor(data?: ISelectOptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): SelectOptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SelectOptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["order"] = this.order;
        return data; 
    }
}

export interface ISelectOptionResponse {
    id: string;
    label: string;
    order: number;
}

export class MultiSelectFormFieldResponse extends EditableFormFieldResponse implements IMultiSelectFormFieldResponse {
    options!: SelectOptionResponse[];
    selectedOptions!: SelectOptionResponse[];
    hasOther!: boolean;
    otherLabel?: string | undefined;
    otherValue?: string | undefined;

    constructor(data?: IMultiSelectFormFieldResponse) {
        super(data);
        if (!data) {
            this.options = [];
            this.selectedOptions = [];
        }
        this._discriminator = "MultiSelectFormFieldResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(SelectOptionResponse.fromJS(item));
            }
            if (Array.isArray(_data["selectedOptions"])) {
                this.selectedOptions = [] as any;
                for (let item of _data["selectedOptions"])
                    this.selectedOptions!.push(SelectOptionResponse.fromJS(item));
            }
            this.hasOther = _data["hasOther"];
            this.otherLabel = _data["otherLabel"];
            this.otherValue = _data["otherValue"];
        }
    }

    static fromJS(data: any): MultiSelectFormFieldResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MultiSelectFormFieldResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        if (Array.isArray(this.selectedOptions)) {
            data["selectedOptions"] = [];
            for (let item of this.selectedOptions)
                data["selectedOptions"].push(item.toJSON());
        }
        data["hasOther"] = this.hasOther;
        data["otherLabel"] = this.otherLabel;
        data["otherValue"] = this.otherValue;
        super.toJSON(data);
        return data; 
    }
}

export interface IMultiSelectFormFieldResponse extends IEditableFormFieldResponse {
    options: SelectOptionResponse[];
    selectedOptions: SelectOptionResponse[];
    hasOther: boolean;
    otherLabel?: string | undefined;
    otherValue?: string | undefined;
}

export class RiskFormFieldResponse extends EditableFormFieldResponse implements IRiskFormFieldResponse {
    probabilityOptions!: RiskOptionResponse[];
    impactOptions!: RiskOptionResponse[];
    selectedProbabilityOption?: RiskOptionResponse | undefined;
    selectedImpactOption?: RiskOptionResponse | undefined;
    probabilityLabel!: string;
    impactLabel!: string;
    riskScore?: number | undefined;

    constructor(data?: IRiskFormFieldResponse) {
        super(data);
        if (!data) {
            this.probabilityOptions = [];
            this.impactOptions = [];
        }
        this._discriminator = "RiskFormFieldResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["probabilityOptions"])) {
                this.probabilityOptions = [] as any;
                for (let item of _data["probabilityOptions"])
                    this.probabilityOptions!.push(RiskOptionResponse.fromJS(item));
            }
            if (Array.isArray(_data["impactOptions"])) {
                this.impactOptions = [] as any;
                for (let item of _data["impactOptions"])
                    this.impactOptions!.push(RiskOptionResponse.fromJS(item));
            }
            this.selectedProbabilityOption = _data["selectedProbabilityOption"] ? RiskOptionResponse.fromJS(_data["selectedProbabilityOption"]) : <any>undefined;
            this.selectedImpactOption = _data["selectedImpactOption"] ? RiskOptionResponse.fromJS(_data["selectedImpactOption"]) : <any>undefined;
            this.probabilityLabel = _data["probabilityLabel"];
            this.impactLabel = _data["impactLabel"];
            this.riskScore = _data["riskScore"];
        }
    }

    static fromJS(data: any): RiskFormFieldResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RiskFormFieldResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.probabilityOptions)) {
            data["probabilityOptions"] = [];
            for (let item of this.probabilityOptions)
                data["probabilityOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.impactOptions)) {
            data["impactOptions"] = [];
            for (let item of this.impactOptions)
                data["impactOptions"].push(item.toJSON());
        }
        data["selectedProbabilityOption"] = this.selectedProbabilityOption ? this.selectedProbabilityOption.toJSON() : <any>undefined;
        data["selectedImpactOption"] = this.selectedImpactOption ? this.selectedImpactOption.toJSON() : <any>undefined;
        data["probabilityLabel"] = this.probabilityLabel;
        data["impactLabel"] = this.impactLabel;
        data["riskScore"] = this.riskScore;
        super.toJSON(data);
        return data; 
    }
}

export interface IRiskFormFieldResponse extends IEditableFormFieldResponse {
    probabilityOptions: RiskOptionResponse[];
    impactOptions: RiskOptionResponse[];
    selectedProbabilityOption?: RiskOptionResponse | undefined;
    selectedImpactOption?: RiskOptionResponse | undefined;
    probabilityLabel: string;
    impactLabel: string;
    riskScore?: number | undefined;
}

export class RiskOptionResponse implements IRiskOptionResponse {
    id!: string;
    label!: string;
    order!: number;
    riskValue!: number;

    constructor(data?: IRiskOptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.order = _data["order"];
            this.riskValue = _data["riskValue"];
        }
    }

    static fromJS(data: any): RiskOptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RiskOptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["order"] = this.order;
        data["riskValue"] = this.riskValue;
        return data; 
    }
}

export interface IRiskOptionResponse {
    id: string;
    label: string;
    order: number;
    riskValue: number;
}

export class HeaderFormFieldResponse extends FormFieldResponse implements IHeaderFormFieldResponse {

    constructor(data?: IHeaderFormFieldResponse) {
        super(data);
        this._discriminator = "HeaderFormFieldResponse";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): HeaderFormFieldResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HeaderFormFieldResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IHeaderFormFieldResponse extends IFormFieldResponse {
}

export class TextFormFieldResponse extends EditableFormFieldResponse implements ITextFormFieldResponse {
    value?: string | undefined;

    constructor(data?: ITextFormFieldResponse) {
        super(data);
        this._discriminator = "TextFormFieldResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TextFormFieldResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TextFormFieldResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface ITextFormFieldResponse extends IEditableFormFieldResponse {
    value?: string | undefined;
}

export class DateFormFieldResponse extends EditableFormFieldResponse implements IDateFormFieldResponse {
    value?: moment.Moment | undefined;

    constructor(data?: IDateFormFieldResponse) {
        super(data);
        this._discriminator = "DateFormFieldResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? moment(_data["value"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateFormFieldResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DateFormFieldResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.format('YYYY-MM-DD') : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IDateFormFieldResponse extends IEditableFormFieldResponse {
    value?: moment.Moment | undefined;
}

export class DateTimeFormFieldResponse extends EditableFormFieldResponse implements IDateTimeFormFieldResponse {
    value?: moment.Moment | undefined;

    constructor(data?: IDateTimeFormFieldResponse) {
        super(data);
        this._discriminator = "DateTimeFormFieldResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? moment(_data["value"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateTimeFormFieldResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeFormFieldResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toISOString() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IDateTimeFormFieldResponse extends IEditableFormFieldResponse {
    value?: moment.Moment | undefined;
}

export class AnalysisResponse implements IAnalysisResponse {
    formFields!: FormFieldResponse[];
    employeeIdsResponsibleForAnalysis!: string[];

    constructor(data?: IAnalysisResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formFields = [];
            this.employeeIdsResponsibleForAnalysis = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formFields"])) {
                this.formFields = [] as any;
                for (let item of _data["formFields"])
                    this.formFields!.push(FormFieldResponse.fromJS(item));
            }
            if (Array.isArray(_data["employeeIdsResponsibleForAnalysis"])) {
                this.employeeIdsResponsibleForAnalysis = [] as any;
                for (let item of _data["employeeIdsResponsibleForAnalysis"])
                    this.employeeIdsResponsibleForAnalysis!.push(item);
            }
        }
    }

    static fromJS(data: any): AnalysisResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formFields)) {
            data["formFields"] = [];
            for (let item of this.formFields)
                data["formFields"].push(item.toJSON());
        }
        if (Array.isArray(this.employeeIdsResponsibleForAnalysis)) {
            data["employeeIdsResponsibleForAnalysis"] = [];
            for (let item of this.employeeIdsResponsibleForAnalysis)
                data["employeeIdsResponsibleForAnalysis"].push(item);
        }
        return data; 
    }
}

export interface IAnalysisResponse {
    formFields: FormFieldResponse[];
    employeeIdsResponsibleForAnalysis: string[];
}

export class ActionResponse implements IActionResponse {
    expectedResult!: string;
    plannedImplementationDate!: moment.Moment;
    followUpDate!: moment.Moment;
    employeeResponsibleForAction!: string;
    employeesCoResponsibleForAction!: string[];
    employeeResponsibleForFollowUp!: string;
    employeesCoResponsibleForFollowUp!: string[];
    type!: ActionTypeResponse;
    state!: ActionState;
    followUp?: string | undefined;

    constructor(data?: IActionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.employeesCoResponsibleForAction = [];
            this.employeesCoResponsibleForFollowUp = [];
            this.type = new ActionTypeResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expectedResult = _data["expectedResult"];
            this.plannedImplementationDate = _data["plannedImplementationDate"] ? moment(_data["plannedImplementationDate"].toString()) : <any>undefined;
            this.followUpDate = _data["followUpDate"] ? moment(_data["followUpDate"].toString()) : <any>undefined;
            this.employeeResponsibleForAction = _data["employeeResponsibleForAction"];
            if (Array.isArray(_data["employeesCoResponsibleForAction"])) {
                this.employeesCoResponsibleForAction = [] as any;
                for (let item of _data["employeesCoResponsibleForAction"])
                    this.employeesCoResponsibleForAction!.push(item);
            }
            this.employeeResponsibleForFollowUp = _data["employeeResponsibleForFollowUp"];
            if (Array.isArray(_data["employeesCoResponsibleForFollowUp"])) {
                this.employeesCoResponsibleForFollowUp = [] as any;
                for (let item of _data["employeesCoResponsibleForFollowUp"])
                    this.employeesCoResponsibleForFollowUp!.push(item);
            }
            this.type = _data["type"] ? ActionTypeResponse.fromJS(_data["type"]) : new ActionTypeResponse();
            this.state = _data["state"];
            this.followUp = _data["followUp"];
        }
    }

    static fromJS(data: any): ActionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expectedResult"] = this.expectedResult;
        data["plannedImplementationDate"] = this.plannedImplementationDate ? this.plannedImplementationDate.format('YYYY-MM-DD') : <any>undefined;
        data["followUpDate"] = this.followUpDate ? this.followUpDate.format('YYYY-MM-DD') : <any>undefined;
        data["employeeResponsibleForAction"] = this.employeeResponsibleForAction;
        if (Array.isArray(this.employeesCoResponsibleForAction)) {
            data["employeesCoResponsibleForAction"] = [];
            for (let item of this.employeesCoResponsibleForAction)
                data["employeesCoResponsibleForAction"].push(item);
        }
        data["employeeResponsibleForFollowUp"] = this.employeeResponsibleForFollowUp;
        if (Array.isArray(this.employeesCoResponsibleForFollowUp)) {
            data["employeesCoResponsibleForFollowUp"] = [];
            for (let item of this.employeesCoResponsibleForFollowUp)
                data["employeesCoResponsibleForFollowUp"].push(item);
        }
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["state"] = this.state;
        data["followUp"] = this.followUp;
        return data; 
    }
}

export interface IActionResponse {
    expectedResult: string;
    plannedImplementationDate: moment.Moment;
    followUpDate: moment.Moment;
    employeeResponsibleForAction: string;
    employeesCoResponsibleForAction: string[];
    employeeResponsibleForFollowUp: string;
    employeesCoResponsibleForFollowUp: string[];
    type: ActionTypeResponse;
    state: ActionState;
    followUp?: string | undefined;
}

export class ActionTypeResponse implements IActionTypeResponse {
    id!: string;
    type!: string;

    constructor(data?: IActionTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ActionTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActionTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        return data; 
    }
}

export interface IActionTypeResponse {
    id: string;
    type: string;
}

export enum ActionState {
    None = "None",
    Active = "Active",
    Completed = "Completed",
    Archived = "Archived",
}

export class IncidentContentDetailResponse implements IIncidentContentDetailResponse {
    id!: number;
    title!: string;
    organisationId!: string;
    departmentId?: string | undefined;
    state!: IncidentState;
    content!: ContentResponse;

    constructor(data?: IIncidentContentDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.content = new ContentResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.organisationId = _data["organisationId"];
            this.departmentId = _data["departmentId"];
            this.state = _data["state"];
            this.content = _data["content"] ? ContentResponse.fromJS(_data["content"]) : new ContentResponse();
        }
    }

    static fromJS(data: any): IncidentContentDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentContentDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["organisationId"] = this.organisationId;
        data["departmentId"] = this.departmentId;
        data["state"] = this.state;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IIncidentContentDetailResponse {
    id: number;
    title: string;
    organisationId: string;
    departmentId?: string | undefined;
    state: IncidentState;
    content: ContentResponse;
}

export class IncidentFinalCommentDetailResponse implements IIncidentFinalCommentDetailResponse {
    id!: number;
    finalComment?: string | undefined;
    state!: IncidentState;

    constructor(data?: IIncidentFinalCommentDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.finalComment = _data["finalComment"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): IncidentFinalCommentDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentFinalCommentDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["finalComment"] = this.finalComment;
        data["state"] = this.state;
        return data; 
    }
}

export interface IIncidentFinalCommentDetailResponse {
    id: number;
    finalComment?: string | undefined;
    state: IncidentState;
}

export class IncidentPrototypeResponse implements IIncidentPrototypeResponse {
    incidentTemplateId!: string;
    title!: string;
    organisationId!: string;
    departmentId!: string;
    state!: IncidentState;
    content!: ContentResponse;

    constructor(data?: IIncidentPrototypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.content = new ContentResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incidentTemplateId = _data["incidentTemplateId"];
            this.title = _data["title"];
            this.organisationId = _data["organisationId"];
            this.departmentId = _data["departmentId"];
            this.state = _data["state"];
            this.content = _data["content"] ? ContentResponse.fromJS(_data["content"]) : new ContentResponse();
        }
    }

    static fromJS(data: any): IncidentPrototypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentPrototypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidentTemplateId"] = this.incidentTemplateId;
        data["title"] = this.title;
        data["organisationId"] = this.organisationId;
        data["departmentId"] = this.departmentId;
        data["state"] = this.state;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IIncidentPrototypeResponse {
    incidentTemplateId: string;
    title: string;
    organisationId: string;
    departmentId: string;
    state: IncidentState;
    content: ContentResponse;
}

export class DeleteIncidentRequest implements IDeleteIncidentRequest {
    deletedReason!: string;

    constructor(data?: IDeleteIncidentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deletedReason = _data["deletedReason"];
        }
    }

    static fromJS(data: any): DeleteIncidentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteIncidentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deletedReason"] = this.deletedReason;
        return data; 
    }
}

export interface IDeleteIncidentRequest {
    deletedReason: string;
}

export class IncidentTemplateResponse implements IIncidentTemplateResponse {
    id!: string;
    accessControlTagIds!: string[];
    title!: string;

    constructor(data?: IIncidentTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): IncidentTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        data["title"] = this.title;
        return data; 
    }
}

export interface IIncidentTemplateResponse {
    id: string;
    accessControlTagIds: string[];
    title: string;
}

export class UpdateIncidentTemplateAccessControlTagsRequest implements IUpdateIncidentTemplateAccessControlTagsRequest {
    accessControlTagIds!: string[];

    constructor(data?: IUpdateIncidentTemplateAccessControlTagsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateIncidentTemplateAccessControlTagsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIncidentTemplateAccessControlTagsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdateIncidentTemplateAccessControlTagsRequest {
    accessControlTagIds: string[];
}

export class UpdateAnalysisRequest implements IUpdateAnalysisRequest {
    formFields!: FormFieldRequest[];
    employeeIdsResponsibleForAnalysis!: string[];

    constructor(data?: IUpdateAnalysisRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formFields = [];
            this.employeeIdsResponsibleForAnalysis = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formFields"])) {
                this.formFields = [] as any;
                for (let item of _data["formFields"])
                    this.formFields!.push(FormFieldRequest.fromJS(item));
            }
            if (Array.isArray(_data["employeeIdsResponsibleForAnalysis"])) {
                this.employeeIdsResponsibleForAnalysis = [] as any;
                for (let item of _data["employeeIdsResponsibleForAnalysis"])
                    this.employeeIdsResponsibleForAnalysis!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateAnalysisRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAnalysisRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formFields)) {
            data["formFields"] = [];
            for (let item of this.formFields)
                data["formFields"].push(item.toJSON());
        }
        if (Array.isArray(this.employeeIdsResponsibleForAnalysis)) {
            data["employeeIdsResponsibleForAnalysis"] = [];
            for (let item of this.employeeIdsResponsibleForAnalysis)
                data["employeeIdsResponsibleForAnalysis"].push(item);
        }
        return data; 
    }
}

export interface IUpdateAnalysisRequest {
    formFields: FormFieldRequest[];
    employeeIdsResponsibleForAnalysis: string[];
}

export class IncidentAnalysisDetailResponse implements IIncidentAnalysisDetailResponse {
    id!: number;
    organisationId!: string;
    analysis!: AnalysisResponse;

    constructor(data?: IIncidentAnalysisDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.analysis = new AnalysisResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organisationId = _data["organisationId"];
            this.analysis = _data["analysis"] ? AnalysisResponse.fromJS(_data["analysis"]) : new AnalysisResponse();
        }
    }

    static fromJS(data: any): IncidentAnalysisDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentAnalysisDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organisationId"] = this.organisationId;
        data["analysis"] = this.analysis ? this.analysis.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IIncidentAnalysisDetailResponse {
    id: number;
    organisationId: string;
    analysis: AnalysisResponse;
}

export class IncidentActionDetailResponse implements IIncidentActionDetailResponse {
    id!: number;
    organisationId!: string;
    actions!: ActionMetadataResponse[];

    constructor(data?: IIncidentActionDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.actions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organisationId = _data["organisationId"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(ActionMetadataResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IncidentActionDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentActionDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organisationId"] = this.organisationId;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIncidentActionDetailResponse {
    id: number;
    organisationId: string;
    actions: ActionMetadataResponse[];
}

export class ActionMetadataResponse implements IActionMetadataResponse {
    id!: string;
    actionType!: string;
    state!: ActionState;
    plannedImplementationDate!: moment.Moment;
    employeeIdResponsibleForAction!: string;
    followUpDate!: moment.Moment;
    employeeIdResponsibleForFollowUp!: string;

    constructor(data?: IActionMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actionType = _data["actionType"];
            this.state = _data["state"];
            this.plannedImplementationDate = _data["plannedImplementationDate"] ? moment(_data["plannedImplementationDate"].toString()) : <any>undefined;
            this.employeeIdResponsibleForAction = _data["employeeIdResponsibleForAction"];
            this.followUpDate = _data["followUpDate"] ? moment(_data["followUpDate"].toString()) : <any>undefined;
            this.employeeIdResponsibleForFollowUp = _data["employeeIdResponsibleForFollowUp"];
        }
    }

    static fromJS(data: any): ActionMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActionMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actionType"] = this.actionType;
        data["state"] = this.state;
        data["plannedImplementationDate"] = this.plannedImplementationDate ? this.plannedImplementationDate.format('YYYY-MM-DD') : <any>undefined;
        data["employeeIdResponsibleForAction"] = this.employeeIdResponsibleForAction;
        data["followUpDate"] = this.followUpDate ? this.followUpDate.format('YYYY-MM-DD') : <any>undefined;
        data["employeeIdResponsibleForFollowUp"] = this.employeeIdResponsibleForFollowUp;
        return data; 
    }
}

export interface IActionMetadataResponse {
    id: string;
    actionType: string;
    state: ActionState;
    plannedImplementationDate: moment.Moment;
    employeeIdResponsibleForAction: string;
    followUpDate: moment.Moment;
    employeeIdResponsibleForFollowUp: string;
}

export class ActionRequest implements IActionRequest {
    expectedResult!: string;
    plannedImplementationDate!: moment.Moment;
    employeeResponsibleForAction!: string;
    employeesCoResponsibleForAction!: string[];
    employeeResponsibleForFollowUp!: string;
    employeesCoResponsibleForFollowUp!: string[];
    followUpDate!: moment.Moment;
    followUp?: string | undefined;
    typeId!: string;
    state!: ActionState;

    constructor(data?: IActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.employeesCoResponsibleForAction = [];
            this.employeesCoResponsibleForFollowUp = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expectedResult = _data["expectedResult"];
            this.plannedImplementationDate = _data["plannedImplementationDate"] ? moment(_data["plannedImplementationDate"].toString()) : <any>undefined;
            this.employeeResponsibleForAction = _data["employeeResponsibleForAction"];
            if (Array.isArray(_data["employeesCoResponsibleForAction"])) {
                this.employeesCoResponsibleForAction = [] as any;
                for (let item of _data["employeesCoResponsibleForAction"])
                    this.employeesCoResponsibleForAction!.push(item);
            }
            this.employeeResponsibleForFollowUp = _data["employeeResponsibleForFollowUp"];
            if (Array.isArray(_data["employeesCoResponsibleForFollowUp"])) {
                this.employeesCoResponsibleForFollowUp = [] as any;
                for (let item of _data["employeesCoResponsibleForFollowUp"])
                    this.employeesCoResponsibleForFollowUp!.push(item);
            }
            this.followUpDate = _data["followUpDate"] ? moment(_data["followUpDate"].toString()) : <any>undefined;
            this.followUp = _data["followUp"];
            this.typeId = _data["typeId"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): ActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expectedResult"] = this.expectedResult;
        data["plannedImplementationDate"] = this.plannedImplementationDate ? this.plannedImplementationDate.format('YYYY-MM-DD') : <any>undefined;
        data["employeeResponsibleForAction"] = this.employeeResponsibleForAction;
        if (Array.isArray(this.employeesCoResponsibleForAction)) {
            data["employeesCoResponsibleForAction"] = [];
            for (let item of this.employeesCoResponsibleForAction)
                data["employeesCoResponsibleForAction"].push(item);
        }
        data["employeeResponsibleForFollowUp"] = this.employeeResponsibleForFollowUp;
        if (Array.isArray(this.employeesCoResponsibleForFollowUp)) {
            data["employeesCoResponsibleForFollowUp"] = [];
            for (let item of this.employeesCoResponsibleForFollowUp)
                data["employeesCoResponsibleForFollowUp"].push(item);
        }
        data["followUpDate"] = this.followUpDate ? this.followUpDate.format('YYYY-MM-DD') : <any>undefined;
        data["followUp"] = this.followUp;
        data["typeId"] = this.typeId;
        data["state"] = this.state;
        return data; 
    }
}

export interface IActionRequest {
    expectedResult: string;
    plannedImplementationDate: moment.Moment;
    employeeResponsibleForAction: string;
    employeesCoResponsibleForAction: string[];
    employeeResponsibleForFollowUp: string;
    employeesCoResponsibleForFollowUp: string[];
    followUpDate: moment.Moment;
    followUp?: string | undefined;
    typeId: string;
    state: ActionState;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}